import styled from "styled-components";

import { T_HEADER_bold, T_PLAIN_big } from "../../global.style";

export const Header = styled.h2`
    ${T_HEADER_bold};
`;

export const Description = styled.p`
    ${T_PLAIN_big};
`;